import axios from 'axios';
import {React, useEffect, useState} from 'react'
import { HistoricalChart } from '../Config/api';
import { CryptoState } from '../CryptoContext';
import { createTheme, ThemeProvider, makeStyles, CircularProgress } from '@material-ui/core';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto'
import { Chart }            from 'react-chartjs-2'
import {chartDays} from '../Config/data';
import SelectButton from './SelectButton';

const useStyles = makeStyles((theme) => ({
  container: {
    width: "75%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 25,
    padding:40,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: 0,
      padding: 20,
      paddingTop:0
    }
  }
}));

export default function CoinInfo({ coin }) {

  const [historicalData, sethistoricalData] = useState();
  const [days, setdays] = useState();

  const { currency } = CryptoState();

  const fetchHistoricalData = async () => {
    const { data } = await axios.get(HistoricalChart(coin.id, days, currency ));

    sethistoricalData(data.prices)
  };

  useEffect(() => {
    fetchHistoricalData();
  }, [currency, days]);

  const darkTheme = createTheme({
    palette: {
        primary: {
            main: "#fff",
        },
        type: "dark"
    },
});


  
  const classes = useStyles();

  return (
    <ThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        {
          !historicalData ? (
            <CircularProgress
            style= {{color: "blue"}}
            size={250}
            thickness={1}
            />
          ) : (<>
          <Line
          data={{
            labels:historicalData.map((coin) => {
              let date = new Date(coin[0]);
              let time = 
                  date.getHours() > 12 
                  ? `${date.getHours() - 12}: ${date.getMinutes()} PM`
                  : `${date.getHours()}:${date.getMinutes()} AM`

                  return days === 1 ? time : date.toLocaleDateString();
            }),

            datasets: [
             { data:historicalData.map((coin) => coin[1]),
            label: `Price (Past  ${days} Days) in ${currency}`,
            borderColor: '#40DFEF'
          }
            ]
          }}
          options= {{
            elements: {
              point: {
                radius: 1
              }
            }
          }}
          />
          <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent:"space-around",
            width: "100%"
          }}
          >
            {chartDays.map((day) => (
              <SelectButton
              key={day.value}
              onClick={() => {setdays(day.value);}}
              // selected={day.value === days}
              >
                {day.label}
              </SelectButton>
            ))}
          </div>
          </>)
        }
      </div>
    </ThemeProvider>
  )
}
